module.exports = __webpack_public_path__ + "static/media/A7S01208.ec527406.jpg";